/**
 * Brand, Domain and URL on /clicks need the clicks_daily table, which carries
 * all three. mv_campaign_stats does not: it has no brand at all, and its
 * `domain` is the campaign's registered one, absent for 67% of clicks. The UI and get_dynamic_stats already know about them; the
 * matview does not yet, because rebuilding it took production down twice
 * (21-22.09.2026 — see "Інциденти" in docs/TODO.md).
 *
 * On since 23.09.2026: clicks_daily is filled and get_dynamic_stats reads it
 * (20260924100000). Verified against the raw click log on eight days spread
 * over thirteen months - clicks and revenue equal to the last cent.
 *
 * The flag and the fallback in parseClicksParamsFromUrl stay for one more
 * cycle: they are what makes a bad deploy a hidden menu rather than a 500.
 * Remove both when mv_campaign_stats goes.
 */
export const BRAND_DOMAIN_READY = true;

/** Dimensions that exist only once BRAND_DOMAIN_READY is true. */
export const BRAND_DOMAIN_KEYS = new Set(["brand", "domain", "url"]);

/**
 * The Group By value a dimension is known by in the UI is not always the column
 * name a filter uses: grouping by "campaign" filters on `campaign_name`. Every
 * other dimension spells the two the same, so this holds the one exception
 * rather than a full table that would just repeat itself.
 *
 * The keys accepted by a filter are whatever `clicks_dimensions()` returns:
 * campaign_name, brand, domain, url, source, campaign_group, stream,
 * landing_page, offer, affiliate_network, country, region, city, language.
 */
const GROUP_BY_TO_FILTER_KEY: Record<string, string> = {
  campaign: "campaign_name",
};

export const filterKeyForGroupBy = (groupBy: string): string =>
  GROUP_BY_TO_FILTER_KEY[groupBy] ?? groupBy;
